import { useDispatch, useSelector } from "react-redux";
import FileInput from "../../../../components/common/ui/Inputs/FileInput";
import TextInput from "../../../../components/common/ui/Inputs/TextInput";
import { homePageActions } from "../../../../_store/home.slice";
import { showToastNotification } from "../../../../components/common/ui/NotificationModal/ToastNotication";

function DownloadSection({
  Image1,
  Image2,
  Image3,
  File1,
  File2,
  File3,
  errorMessage,
}) {
  const dispatch = useDispatch();

  const { data } = useSelector((x) => x?.home?.homePageContentResponse);

  const homePageData = { ...data };

  const ImageURL = process.env.REACT_APP_API_IMAGE_URL;

  const allowedMimeTypes = ["application/pdf"];

  const handleChange = (e, nameToShow) => {
    debugger;
    const { name, value, type } = e?.target;
    if (value.startsWith(" ")) return;
    if (type === "file") {
      let file = e.target.files[0];
      if (!file) return;

      if (allowedMimeTypes.includes(file.type)) {
        homePageData[nameToShow] = file;
        // pageData.fileCheck = { name: file.name, type: file.type || "" };
      } else {
        showToastNotification("Unsupported Media Type", "error");
        homePageData[nameToShow] = undefined;
        // pageData.fileCheck = undefined;
        e.target.value = ""; // reset input field
        file = "";
        return;
      }

      const formData = new FormData();
      formData.append("image", file);
      if (name === "downloadFirstCardImage") {
        Image1(file);
      }
      if (name === "downloadSecondCardImage") {
        Image2(file);
      }
      if (name === "downloadThirdCardImage") {
        Image3(file);
      }

      if (name === "downloadFirstCardUrl") {
        File1(file);
      }
      if (name === "downloadSecondCardUrl") {
        File2(file);
      }
      if (name === "downloadThirdCardUrl") {
        File3(file);
      }
      if (file) {
        const imageUrl = URL.createObjectURL(file);
        homePageData[nameToShow] = imageUrl;
      }
      dispatch(homePageActions?.updateHomePageResponse(homePageData));
      return;
    }
    homePageData[name] = value;
    dispatch(homePageActions?.updateHomePageResponse(homePageData));
  };

  const firstCardURL = homePageData?.downloadFirstCardUrl?.split("/");
  const secondCardURL = homePageData?.downloadSecondCardUrl?.split("/");
  const thirdCardURL = homePageData?.downloadThirdCardUrl?.split("/");

  const firstCardFileName = firstCardURL?.[firstCardURL?.length - 1];
  const secondCardFileName = secondCardURL?.[secondCardURL?.length - 1];
  const thirdCardFileName = thirdCardURL?.[thirdCardURL?.length - 1];

  return (
    <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
      <h1 className="m-0 search-header-color border-dotted p-3 border-bottom integrate-card-header">
        {/* Download Strategic Plan */}
        Section - 5
      </h1>
      <div className="p-3 row">
        <div className="row mb-4">
          <div className="col-md-4">
            <TextInput
              label="Title"
              name="downloadSectionMainTitle"
              value={homePageData.downloadSectionMainTitle}
              placeholder="Main Title"
              handleChange={(e) => {
                handleChange(e);
              }}
              errorMessage={errorMessage}
              required
            />
          </div>
        </div>
        <div className="row mb-4">
          <div className="col-md-4">
            <TextInput
              name="downloadFirstCardTitle"
              value={homePageData.downloadFirstCardTitle}
              label="Card Title"
              placeholder="Card Title"
              handleChange={(e) => {
                handleChange(e);
              }}
              errorMessage={errorMessage}
              required
            />
          </div>
          <div className="col-md-4">
            <FileInput
              name="downloadFirstCardImage"
              label="Card Image"
              handleFileChange={(e) => {
                handleChange(e, "downloadFirstCardImageToShow");
              }}
              imageURL={
                homePageData?.downloadFirstCardImageToShow === undefined
                  ? ImageURL + homePageData?.downloadFirstCardImage
                  : homePageData?.downloadFirstCardImageToShow
              }
              errorMessage={errorMessage}
              required
            />
          </div>
          <div className="col-md-4">
            <FileInput
              name="downloadFirstCardUrl"
              value={homePageData.downloadFirstCardUrl}
              label="Download File"
              handleFileChange={(e) => {
                handleChange(e, "downloadFirstCardUrl");
              }}
              errorMessage={errorMessage}
              required
            />
            <p className="text-gray">{firstCardFileName}</p>
          </div>
        </div>
        <div className="row mb-4">
          <div className="col-md-4">
            <TextInput
              name="downloadSecondCardTitle"
              value={homePageData.downloadSecondCardTitle}
              label="Card Title"
              placeholder="Card Title"
              handleChange={(e) => {
                handleChange(e);
              }}
              required
              errorMessage={errorMessage}
            />
          </div>
          <div className="col-md-4">
            <FileInput
              name="downloadSecondCardImage"
              value={homePageData.downloadSecondCardImage}
              label="Card Image"
              handleFileChange={(e) => {
                handleChange(e, "downloadSecondCardImageToShow");
              }}
              imageURL={
                homePageData?.downloadSecondCardImageToShow === undefined
                  ? ImageURL + homePageData?.downloadSecondCardImage
                  : homePageData?.downloadSecondCardImageToShow
              }
              errorMessage={errorMessage}
              required
            />
          </div>
          <div className="col-md-4">
            <FileInput
              name="downloadSecondCardUrl"
              value={homePageData.downloadSecondCardUrl}
              label="Download File"
              handleFileChange={(e) => {
                handleChange(e, "downloadSecondCardUrl");
              }}
              required
              errorMessage={errorMessage}
            />
            <p className="text-gray">{secondCardFileName}</p>
          </div>
        </div>
        <div className="row mb-4">
          <div className="col-md-4">
            <TextInput
              name="downloadThirdCardTitle"
              value={homePageData.downloadThirdCardTitle}
              label="Card Title"
              placeholder="Card Title"
              handleChange={(e) => {
                handleChange(e);
              }}
              errorMessage={errorMessage}
              required
            />
          </div>
          <div className="col-md-4">
            <FileInput
              name="downloadThirdCardImage"
              value={homePageData.downloadThirdCardImage}
              label="Card Image"
              handleFileChange={(e) => {
                handleChange(e, "downloadThirdCardImageToShow");
              }}
              imageURL={
                homePageData?.downloadThirdCardImageToShow === undefined
                  ? ImageURL + homePageData?.downloadThirdCardImage
                  : homePageData?.downloadThirdCardImageToShow
              }
              required
              errorMessage={errorMessage}
            />
          </div>
          <div className="col-md-4">
            <FileInput
              name="downloadThirdCardUrl"
              value={homePageData.downloadThirdCardUrl}
              label="Download File"
              handleFileChange={(e) => {
                handleChange(e, "downloadThirdCardUrl");
              }}
              errorMessage={errorMessage}
              required
            />

            <p className="text-gray">{thirdCardFileName}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DownloadSection;
